import request from "../../utils/request";

export const getContests = (params) => {
    return request.get('/contests', {
        params
    })
}

export const getContestDetail = (title) => {
    return request.get(`/contests/${title}`)
}